import { ISelectModel } from 'common/models';
import API from 'services/api';

export const getRootCalculationStatusTypes = (): Promise<ISelectModel<number>[]> =>
  API.get('api/root/calculation-statuses/all').then(response => response?.data);
